var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67711 11.1864C6.25667 11.6737 7.49325 12.9103 7.98064 14.4899L9.16667 18.3337L10.3527 14.4899C10.8401 12.9103 12.0767 11.6737 13.6562 11.1864L17.5 10.0003L13.6562 8.8143C12.0767 8.32691 10.8401 7.09033 10.3527 5.51077L9.16667 1.66699L7.98064 5.51077C7.49325 7.09033 6.25667 8.32691 4.67711 8.8143L0.833334 10.0003L4.67711 11.1864Z",
    fill: "#FAFF0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2239 4.28163C14.5398 4.37911 14.7872 4.62642 14.8846 4.94234L15.4166 6.66634L15.9485 4.94233C16.046 4.62642 16.2933 4.37911 16.6092 4.28163L18.3333 3.74967L16.6092 3.21772C16.2933 3.12024 16.046 2.87293 15.9485 2.55701L15.4166 0.833008L14.8846 2.55701C14.7872 2.87293 14.5398 3.12024 14.2239 3.21772L12.4999 3.74967L14.2239 4.28163Z",
    fill: "#FAFF0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2239 16.7816C14.5398 16.8791 14.7872 17.1264 14.8846 17.4423L15.4166 19.1663L15.9485 17.4423C16.046 17.1264 16.2933 16.8791 16.6092 16.7816L18.3333 16.2497L16.6092 15.7177C16.2933 15.6202 16.046 15.3729 15.9485 15.057L15.4166 13.333L14.8846 15.057C14.7872 15.3729 14.5398 15.6202 14.2239 15.7177L12.4999 16.2497L14.2239 16.7816Z",
    fill: "#FAFF0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.a7e3c5015b455b7283638c4bff0e53eb.svg";
export { ForwardRef as ReactComponent };